import _Typewriter from 'typewriter-effect/dist/core';

/** @type {new (element: HTMLElement, options?: import('typewriter-effect').Options & { pauseFor: number }) => import('typewriter-effect').TypewriterClass} */
const Typewriter = _Typewriter;

export default class TypewriterCTA {

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.handleWindowResize = this.handleWindowResize.bind(this);

		/** @type {HTMLElement} */
		this.element = element;
		if (!(this.element instanceof HTMLElement)) {
			throw new Error('Could not construct TyperwiterCTA: No element found');
		}

		/** @type {HTMLElement} */
		this.messageElement = this.element.querySelector('.gigs-typewriter-cta__message--sentinel');
		if (!(this.messageElement instanceof HTMLElement)) {
			throw new Error('Could not construct TypewriterCTA: No message sentinel element found');
		}

		/** @type {NodeListOf<HTMLElement>} */
		this.messageSizerElements = this.element.querySelectorAll('.gigs-typewriter-cta__message--sizer');
		if (this.messageSizerElements.length < 1) {
			throw new Error('Could not construct TypewriterCTA: No message sizer elements found');
		}

		/** @type {string[]} */
		this.messages = JSON.parse(this.element.dataset.messages);
		if (!Array.isArray(this.messages)) {
			throw new Error('Could not construct TypewriterCTA: No messages array found');
		}
		if (this.messages.some(message => (typeof message !== 'string'))) {
			throw new Error('Could not construct TypewriterCTA: Messages are not strings');
		}

		/** @type {import('typewriter-effect').TypewriterClass | null} */
		this.instance = null;
	}

	handleWindowResize() {
		this.setMessageElementHeight();
	}

	setMessageElementHeight() {
		/** @type {number} */
		let height = 0;
		this.messageSizerElements.forEach(element => {
			if (element.offsetHeight > height) {
				height = element.offsetHeight;
			}
		});
		this.messageElement.style.height = `${height}px`;
	}

	init() {
		this.setMessageElementHeight();
		window.addEventListener('resize', this.handleWindowResize, { passive: true });
		this.instance = new Typewriter(this.messageElement, {
			strings: this.messages,
			loop: true,
			autoStart: true,
			delay: 50,
			deleteSpeed: 25,
			pauseFor: 5000,
		});
	}

	destroy() {
		window.removeEventListener('resize', this.handleWindowResize);
		if (this.instance) {
			this.instance.stop().deleteAll(0);
			this.instance = null;
		}
	}
}
